import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { db } from './db/db';
import './styles.css';

async function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  const { registerSW } = await import('virtual:pwa-register');
  const updateSW = registerSW({
    onNeedRefresh() {
      window.dispatchEvent(new CustomEvent('habitos:update', { detail: () => void updateSW(true) }));
    },
  });
}

async function boot() {
  const root = createRoot(document.getElementById('root')!);
  let storageError = false;
  try {
    await db.open();
  } catch (err) {
    console.error('[HabitOS] IndexedDB no disponible', err);
    storageError = true;
  }
  root.render(
    <StrictMode>
      <App storageError={storageError} />
    </StrictMode>,
  );
  void registerServiceWorker();
}

void boot();
